'use strict';

var angular = require('angular');
var InversionModalDirective = function InversionModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/inversion-modal.html'),
    link: function link($scope, element) {
      $scope.$watch('showWarningModal', function (newVal) {
        if (newVal) {
          angular.element('#fares-inversion-modal').modal('show');
        } else {
          element.parent('.modal:first').modal('hide');
        }
      });
    }
  };
};
InversionModalDirective.$inject = [];
module.exports = InversionModalDirective;